import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import alertIconImg from "@static/img/dashboard/alert.svg";

export const AlertIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={alertIconImg} viewBox="0 0 30 30" />;
};
